export function headerbtn() {
  $('.js-headerbtn').on('click' , function(){
    $('.js-hamburgerTrigger').removeClass('is-active');
    $('.js-hamburgerTrigger').addClass('is-close');
    $('.l-header').removeClass('is-active');
    $('.l-headerSp').removeClass('is-view');
  });
}
